(function () {
  var form = document.getElementById('JobApplicationForm');
  var section = form ? form.closest('.job-application') : document.querySelector('.job-application');
  const statusEl = section ? section.querySelector('[id="JobApplicationFormStatus"]') : document.getElementById('JobApplicationFormStatus');
  const submitBtn = document.getElementById('JobApplicationFormSubmit');
  const resumeInput = document.getElementById('JobApplicationForm-resume');
  const videoInput = document.getElementById('JobApplicationForm-video');
  const resumeNameEl = document.getElementById('JobApplicationForm-resume-name');
  const videoNameEl = document.getElementById('JobApplicationForm-video-name');
  const paintedJobsLanguage = (document.documentElement.lang || '').toLowerCase();
  const paintedJobsSpanish = paintedJobsLanguage.startsWith('es');
  const paintedJobsGerman = paintedJobsLanguage.startsWith('de');
  function paintedJobsCopy(english, spanish, german) {
    if (paintedJobsGerman) return german;
    return paintedJobsSpanish ? spanish : english;
  }

  function getFormWrapper() {
    return form.parentElement;
  }

  var overlayEl = null;
  function getOverlay() {
    if (overlayEl) return overlayEl;
    overlayEl = document.createElement('div');
    overlayEl.className = 'job-application__overlay hidden';
    overlayEl.setAttribute('aria-hidden', 'true');
    overlayEl.setAttribute('aria-modal', 'true');
    overlayEl.setAttribute('role', 'dialog');
    overlayEl.setAttribute('aria-labelledby', 'JobApplicationOverlayTitle');
    overlayEl.innerHTML = '<div class="job-application__overlay-content"><p class="job-application__overlay-title" id="JobApplicationOverlayTitle">Uploading…</p><div class="job-application__progress-item" id="JobApplicationProgress-resume"><span class="job-application__progress-label">Resume</span><div class="job-application__progress-bar"><div class="job-application__progress-fill" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div><span class="job-application__progress-pct">0%</span></div><div class="job-application__progress-item" id="JobApplicationProgress-video"><span class="job-application__progress-label">Video</span><div class="job-application__progress-bar"><div class="job-application__progress-fill" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div><span class="job-application__progress-pct">0%</span></div><div class="job-application__overlay-processing hidden" id="JobApplicationOverlayProcessing" aria-live="polite"><span class="job-application__overlay-spinner" aria-hidden="true"></span><span>Finalizing...</span></div><button type="button" class="button job-application__overlay-cancel" id="JobApplicationCancelBtn">Cancel</button></div>';
    if (paintedJobsSpanish) {
      overlayEl.querySelector('#JobApplicationOverlayTitle').textContent = 'Subiendo…';
      overlayEl.querySelector('#JobApplicationProgress-resume .job-application__progress-label').textContent = 'Currículum';
      overlayEl.querySelector('#JobApplicationOverlayProcessing span:last-child').textContent = 'Finalizando...';
      overlayEl.querySelector('#JobApplicationCancelBtn').textContent = 'Cancelar';
    } else if (paintedJobsGerman) {
      overlayEl.querySelector('#JobApplicationOverlayTitle').textContent = 'Wird hochgeladen…';
      overlayEl.querySelector('#JobApplicationProgress-resume .job-application__progress-label').textContent = 'Lebenslauf';
      overlayEl.querySelector('#JobApplicationOverlayProcessing span:last-child').textContent = 'Wird abgeschlossen...';
      overlayEl.querySelector('#JobApplicationCancelBtn').textContent = 'Abbrechen';
    }
    document.body.appendChild(overlayEl);
    var cancelBtn = overlayEl.querySelector('.job-application__overlay-cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function () {
        cancelUploads();
        hideOverlay();
        setSubmitDisabled(false);
        showStatus(paintedJobsCopy('Upload cancelled.', 'Carga cancelada.', 'Upload abgebrochen.'), true);
      });
    }
    return overlayEl;
  }

  const config = window.jobApplicationConfig || {};
  const roleVideoRequired = window.jobApplicationRoleVideoRequired || {};
  const backendUrl = (config.backendUrl || '').replace(/\/$/, '');
  const maxVideoSizeBytes = config.maxVideoSizeBytes || 500 * 1024 * 1024;

  function updateVideoRequired() {
    var roleSelect = document.getElementById('JobApplicationForm-role');
    var videoAsterisk = document.getElementById('JobApplicationForm-video-asterisk');
    if (!videoInput || !roleSelect) return;
    var role = (roleSelect.value || '').trim();
    var required = !!roleVideoRequired[role];
    videoInput.required = required;
    if (videoAsterisk) videoAsterisk.textContent = required ? '*' : '';
  }

  let activeXhrs = [];

  if (!backendUrl) {
    console.warn('Job application: backend_url not set in section settings.');
  }

  function formatSize(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1) + ' MB';
    if (bytes >= 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return bytes + ' B';
  }

  function showStatus(message, isError) {
    if (!statusEl) return;
    statusEl.classList.remove('hidden', 'job-application__status--success', 'job-application__status--error');
    statusEl.classList.add(isError ? 'job-application__status--error' : 'job-application__status--success');
    statusEl.innerHTML = (isError ? '\u274C ' : '\u2705 ') + message;
    statusEl.setAttribute('tabindex', '-1');
    statusEl.focus();
  }

  function hideStatus() {
    if (statusEl) statusEl.classList.add('hidden');
  }

  function setProgress(type, percent) {
    var overlay = getOverlay();
    var item = overlay ? overlay.querySelector('[id="JobApplicationProgress-' + type + '"]') : document.getElementById('JobApplicationProgress-' + type);
    if (!item) return;
    var fill = item.querySelector('.job-application__progress-fill');
    var pct = item.querySelector('.job-application__progress-pct');
    if (fill) {
      fill.style.width = percent + '%';
      fill.setAttribute('aria-valuenow', Math.round(percent));
    }
    if (pct) pct.textContent = Math.round(percent) + '%';
  }

  function showOverlay() {
    var overlay = getOverlay();
    if (overlay) {
      overlay.classList.remove('hidden');
      overlay.setAttribute('aria-hidden', 'false');
    }
  }

  function hideOverlay() {
    var overlay = getOverlay();
    if (overlay) {
      overlay.classList.add('hidden');
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  function resetOverlayState() {
    var overlay = getOverlay();
    if (!overlay) return;
    var title = overlay.querySelector('#JobApplicationOverlayTitle');
    if (title) title.textContent = paintedJobsCopy('Uploading…', 'Subiendo…', 'Wird hochgeladen…');
    var processing = overlay.querySelector('#JobApplicationOverlayProcessing');
    if (processing) processing.classList.add('hidden');
    var cancelBtn = overlay.querySelector('.job-application__overlay-cancel');
    if (cancelBtn) cancelBtn.classList.remove('hidden');
    var videoProgressEl = overlay.querySelector('#JobApplicationProgress-video');
    if (videoProgressEl) videoProgressEl.classList.remove('job-application__progress-item--hidden');
  }

  function showProcessing() {
    var overlay = getOverlay();
    if (!overlay) return;
    var title = overlay.querySelector('#JobApplicationOverlayTitle');
    if (title) title.textContent = 'Processing…';
    var processing = overlay.querySelector('#JobApplicationOverlayProcessing');
    if (processing) processing.classList.remove('hidden');
    var cancelBtn = overlay.querySelector('.job-application__overlay-cancel');
    if (cancelBtn) cancelBtn.classList.add('hidden');
  }

  function setSubmitDisabled(disabled) {
    if (submitBtn) submitBtn.disabled = disabled;
  }

  function getPresignedUrl(type, filename) {
    const params = new URLSearchParams({
      action: 'presign',
      type: type,
      filename: filename || 'file'
    });
    return fetch(backendUrl + '?' + params.toString(), { method: 'GET' })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to get upload URL');
        return res.json();
      });
  }

  function uploadToS3(file, uploadUrl, type) {
    return new Promise(function (resolve, reject) {
      const xhr = new XMLHttpRequest();
      activeXhrs.push(xhr);

      xhr.upload.addEventListener('progress', function (e) {
        if (e.lengthComputable) {
          const pct = (e.loaded / e.total) * 100;
          setProgress(type, pct);
        }
      });

      xhr.addEventListener('load', function () {
        activeXhrs = activeXhrs.filter(function (x) { return x !== xhr; });
        if (xhr.status >= 200 && xhr.status < 300) resolve();
        else reject(new Error('Upload failed: ' + xhr.status));
      });
      xhr.addEventListener('error', function () {
        activeXhrs = activeXhrs.filter(function (x) { return x !== xhr; });
        reject(new Error('Upload failed'));
      });
      xhr.addEventListener('abort', function () {
        activeXhrs = activeXhrs.filter(function (x) { return x !== xhr; });
        reject(new Error('Upload cancelled'));
      });

      xhr.open('PUT', uploadUrl);
      xhr.setRequestHeader('Content-Type', 'application/octet-stream');
      xhr.send(file);
    });
  }

  function cancelUploads() {
    activeXhrs.forEach(function (xhr) { xhr.abort(); });
    activeXhrs = [];
  }

  if (form) {
  resumeInput && resumeInput.addEventListener('change', function () {
    var file = this.files && this.files[0];
    if (file) {
      resumeNameEl.textContent = file.name + ' (' + formatSize(file.size) + ')';
    } else {
      resumeNameEl.textContent = '';
    }
  });
  videoInput && videoInput.addEventListener('change', function () {
    var file = this.files && this.files[0];
    if (file) {
      videoNameEl.textContent = file.name + ' (' + formatSize(file.size) + ')';
      if (file.size > maxVideoSizeBytes) {
        showStatus(paintedJobsCopy('Video file is too large. Maximum size is ', 'El archivo de video es demasiado grande. El tamaño máximo es ', 'Die Videodatei ist zu groß. Die maximale Größe beträgt ') + Math.round(maxVideoSizeBytes / 1024 / 1024) + ' MB.', true);
      } else {
        hideStatus();
      }
    } else {
      videoNameEl.textContent = '';
    }
  });

  var roleSelect = form && document.getElementById('JobApplicationForm-role');
  if (roleSelect) {
    roleSelect.addEventListener('change', updateVideoRequired);
    updateVideoRequired();
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!backendUrl) {
      showStatus(paintedJobsCopy('Form is not configured. Please set the Backend URL in the theme editor.', 'El formulario no está configurado. Configura la URL del servidor en el editor del tema.', 'Das Formular ist nicht konfiguriert. Bitte lege die Backend-URL im Theme-Editor fest.'), true);
      return;
    }

    const first_name = ((document.getElementById('JobApplicationForm-first_name') || {}).value || '').trim();
    const last_name = ((document.getElementById('JobApplicationForm-last_name') || {}).value || '').trim();
    const email = ((document.getElementById('JobApplicationForm-email') || {}).value || '').trim();
    const phone = (document.getElementById('JobApplicationForm-phone') || {}).value || '';
    const instagram = (document.getElementById('JobApplicationForm-instagram') || {}).value || '';
    const tiktok = (document.getElementById('JobApplicationForm-tiktok') || {}).value || '';
    const city_suburb = ((document.getElementById('JobApplicationForm-city') || {}).value || '').trim();
    const role = (document.getElementById('JobApplicationForm-role') || {}).value || '';
    const honeypot = ((document.getElementById('JobApplicationForm-website') || {}).value || '').trim();
    const resumeFile = resumeInput && resumeInput.files && resumeInput.files[0];
    const videoFile = videoInput && videoInput.files && videoInput.files[0];

    if (!first_name) {
      showStatus(paintedJobsCopy('Please enter your First Name.', 'Introduce tu nombre.', 'Bitte gib deinen Vornamen ein.'), true);
      return;
    }
    if (!last_name) {
      showStatus(paintedJobsCopy('Please enter your Last Name.', 'Introduce tu apellido.', 'Bitte gib deinen Nachnamen ein.'), true);
      return;
    }
    if (!email) {
      showStatus(paintedJobsCopy('Please enter your Email address.', 'Introduce tu correo electrónico.', 'Bitte gib deine E-Mail-Adresse ein.'), true);
      return;
    }
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showStatus(paintedJobsCopy('Please enter a valid Email address.', 'Introduce un correo electrónico válido.', 'Bitte gib eine gültige E-Mail-Adresse ein.'), true);
      return;
    }
    if (!city_suburb) {
      showStatus(paintedJobsCopy('Please enter your City or Suburb.', 'Introduce tu ciudad o suburbio.', 'Bitte gib deine Stadt oder deinen Vorort ein.'), true);
      return;
    }

    if (!role) {
      showStatus(paintedJobsCopy('Please select a Role.', 'Selecciona un puesto.', 'Bitte wähle eine Stelle aus.'), true);
      return;
    }
    var videoRequired = !!roleVideoRequired[role];
    if (!resumeFile) {
      showStatus(paintedJobsCopy('Please select a Resume file.', 'Selecciona un archivo de currículum.', 'Bitte wähle eine Lebenslaufdatei aus.'), true);
      return;
    }
    if (videoRequired && !videoFile) {
      showStatus(paintedJobsCopy('A video file is required for this role.', 'Este puesto requiere un archivo de video.', 'Für diese Stelle ist eine Videodatei erforderlich.'), true);
      return;
    }

    var allowedResumeExtensions = ['pdf', 'doc', 'docx', 'rtf', 'txt'];
    var allowedVideoExtensions = ['mp4', 'mov'];
    function getExtension(name) {
      var parts = (name || '').split('.');
      return parts.length > 1 ? parts.pop().toLowerCase() : '';
    }
    var resumeExt = getExtension(resumeFile.name);
    if (allowedResumeExtensions.indexOf(resumeExt) === -1) {
      showStatus(paintedJobsCopy('Resume must be a PDF, DOC, DOCX, RTF or TXT file.', 'El currículum debe ser un archivo PDF, DOC, DOCX, RTF o TXT.', 'Der Lebenslauf muss eine PDF-, DOC-, DOCX-, RTF- oder TXT-Datei sein.'), true);
      return;
    }
    if (videoFile) {
      if (videoFile.size > maxVideoSizeBytes) {
        showStatus(paintedJobsCopy('Video file is too large. Maximum size is ', 'El archivo de video es demasiado grande. El tamaño máximo es ', 'Die Videodatei ist zu groß. Die maximale Größe beträgt ') + Math.round(maxVideoSizeBytes / 1024 / 1024) + ' MB.', true);
        return;
      }
      var videoExt = getExtension(videoFile.name);
      if (allowedVideoExtensions.indexOf(videoExt) === -1) {
        showStatus(paintedJobsCopy('Video must be an MP4 or MOV file.', 'El video debe ser un archivo MP4 o MOV.', 'Das Video muss eine MP4- oder MOV-Datei sein.'), true);
        return;
      }
    }

    setSubmitDisabled(true);
    hideStatus();
    setProgress('resume', 0);
    setProgress('video', 0);
    if (!videoFile) setProgress('video', 100);
    resetOverlayState();
    showOverlay();
    var videoProgressEl = getOverlay() && getOverlay().querySelector('#JobApplicationProgress-video');
    if (videoProgressEl) {
      if (videoFile) videoProgressEl.classList.remove('job-application__progress-item--hidden');
      else videoProgressEl.classList.add('job-application__progress-item--hidden');
    }

    function safeFilename(name) {
      return name.replace(/[^a-zA-Z0-9._-]/g, '_').slice(-80) || 'file';
    }

    const resumeFilename = safeFilename(resumeFile.name);
    const videoFilename = videoFile ? safeFilename(videoFile.name) : '';

    var resumePromise = getPresignedUrl('resume', resumeFilename).then(function (data) {
      return uploadToS3(resumeFile, data.upload_url, 'resume').then(function () { return data.file_url; });
    });
    var videoPromise = videoFile
      ? getPresignedUrl('video', videoFilename).then(function (data) {
          return uploadToS3(videoFile, data.upload_url, 'video').then(function () { return data.file_url; });
        })
      : Promise.resolve('');

    Promise.all([resumePromise, videoPromise])
      .then(function (urls) {
        const resume_url = urls[0];
        const video_url = urls[1] || '';
        setProgress('resume', 100);
        setProgress('video', 100);
        showProcessing();

        return fetch(backendUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            first_name: first_name,
            last_name: last_name,
            email: email,
            phone: phone,
            instagram: instagram,
            tiktok: tiktok,
            city_suburb: city_suburb,
            role: role,
            resume_url: resume_url,
            video_url: video_url,
            video_required: videoRequired,
            website: honeypot
          })
        });
      })
      .then(function (res) {
        const contentType = res.headers.get('Content-Type') || '';
        const isJson = contentType.indexOf('application/json') !== -1;
        return (isJson ? res.json() : res.text()).then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        });
      })
      .then(function (result) {
        hideOverlay();
        if (result.ok) {
          var wrapper = getFormWrapper();
          if (wrapper) wrapper.classList.add('job-application__form-wrapper--hidden');
          showStatus(paintedJobsCopy('Thank you! Your application has been submitted successfully.', '¡Gracias! Tu solicitud se envió correctamente.', 'Vielen Dank! Deine Bewerbung wurde erfolgreich übermittelt.'), false);
          form.reset();
          resumeNameEl.textContent = '';
          videoNameEl.textContent = '';
        } else {
          const msg = (result.body && result.body.message) || result.body || paintedJobsCopy('Something went wrong. Please try again.', 'Algo salió mal. Inténtalo de nuevo.', 'Etwas ist schiefgelaufen. Bitte versuche es erneut.');
          showStatus(typeof msg === 'string' ? msg : paintedJobsCopy('Submission failed. Please try again.', 'No se pudo enviar la solicitud. Inténtalo de nuevo.', 'Die Bewerbung konnte nicht übermittelt werden. Bitte versuche es erneut.'), true);
        }
      })
      .catch(function (err) {
        hideOverlay();
        if (err && err.message === 'Upload cancelled') return;
        showStatus(err && err.message ? err.message : paintedJobsCopy('Something went wrong. Please try again.', 'Algo salió mal. Inténtalo de nuevo.', 'Etwas ist schiefgelaufen. Bitte versuche es erneut.'), true);
      })
      .finally(function () {
        setSubmitDisabled(false);
      });
  });
  }

  function initReadMore() {
    var containers = document.querySelectorAll('.job-application [data-job-description]');
    containers.forEach(function (container) {
      var content = container.querySelector('.job-application__job-description-content');
      var btn = container.querySelector('.job-application__read-more');
      if (!content || !btn) return;
      var children = content.children;
      if (children.length <= 1) {
        btn.classList.add('hidden');
        return;
      }
      var rest = document.createElement('div');
      rest.className = 'job-application__job-description-rest';
      while (children.length > 1) {
        rest.appendChild(children[1]);
      }
      content.appendChild(rest);

      btn.addEventListener('click', function () {
        var expanded = container.classList.toggle('job-application__job-description--expanded');
        btn.setAttribute('aria-expanded', expanded);
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });
    });
  }

  initReadMore();
})();
